import { Dispatch, useEffect, useState } from "react";
import { FaDatabase, FaBars, FaHive, FaWrench, FaCog, FaChartLine, FaComments, FaRobot } from "react-icons/fa";
import {  Nav,} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { ObjectId } from "../../models";

type Props = {
    agentId: ObjectId,
    orgId: ObjectId;
    setSideBarWidth: Dispatch<React.SetStateAction<number>>
}

const Sidebar = ({agentId, orgId, setSideBarWidth} : Props) => {
    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    
    const toggleSidebar = () => {
        setCollapsed(!collapsed);
        setSideBarWidth(collapsed ? 250 : 80);
    };

    const isActiveRoute = (route: string) => {
        return location.pathname.includes(route);
    };

    useEffect(()=>{
        const handleResize = () => {
            setCollapsed(window.innerWidth < 768);
            setSideBarWidth(window.innerWidth < 768 ? 80 : 250);
        }
        handleResize();
        window.addEventListener('resize', handleResize);
    }, []);

    const navigationItems = [
        { to: `/dashboard/orgs/${orgId}/${agentId}/data`, icon: FaDatabase, label: "DATA", route: "data" },
        { to: `/dashboard/orgs/${orgId}/${agentId}/configure`, icon: FaWrench, label: "CONFIGURE", route: "configure" },
        { to: `/dashboard/orgs/${orgId}/${agentId}/deploy`, icon: FaHive, label: "DEPLOY", route: "deploy" },
        { to: `/dashboard/orgs/${orgId}/${agentId}/activity`, icon: FaComments, label: "ACTIVITY", route: "activity" },
        { to: `/dashboard/orgs/${orgId}/${agentId}/marketing`, icon: FaChartLine, label: "ANALYTICS", route: "marketing" },
        { to: `/dashboard/orgs/${orgId}/${agentId}/settings`, icon: FaCog, label: "SETTINGS", route: "settings" }
    ];

    return (
        <div style={{ backgroundColor: "#2d2d2d", height: "100vh", borderRight: "1px solid #444" }}>
            <div className="p-3" style={{ borderBottom: "1px solid #444" }}>
                <div className="d-flex align-items-center justify-content-between">
                    {!collapsed && (
                        <div className="d-flex align-items-center">
                            <div className="bg-primary rounded p-2 me-2">
                                <FaRobot className="text-white" size={16} />
                            </div>
                            <small className="text-light fw-bold">Agent Panel</small>
                        </div>
                    )}
                    <button 
                        onClick={toggleSidebar} 
                        className="btn btn-outline-secondary btn-sm border-0"
                        style={{ color: "#ccc" }}
                    >
                        <FaBars size={18} />
                    </button>
                </div>
            </div>
            
            <Nav className="flex-column p-2">
                {navigationItems.map((item, index) => {
                    const Icon = item.icon;
                    const isActive = isActiveRoute(item.route);
                    return (
                        <Nav.Item key={index} className="mb-1">
                            <Nav.Link 
                                as={Link} 
                                to={item.to}
                                className="d-flex align-items-center py-3 px-3 rounded text-decoration-none"
                                style={{
                                    backgroundColor: isActive ? "#444" : "transparent",
                                    borderLeft: isActive ? "3px solid #007bff" : "3px solid transparent",
                                    color: isActive ? "#fff" : "#ccc",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <Icon size={20} />
                                {!collapsed && (
                                    <span className="ms-3 fw-medium" style={{ fontSize: "14px" }}>
                                        {item.label}
                                    </span>
                                )}
                            </Nav.Link>
                        </Nav.Item>
                    );
                })}
            </Nav>
        </div>
    );
};

export default Sidebar;
